import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-263fc809"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "coupon-wrapper" }
const _hoisted_3 = { class: "coupon-card" }
const _hoisted_4 = { class: "coupon-content" }
const _hoisted_5 = { class: "coupon-info" }
const _hoisted_6 = { class: "coupon-title" }
const _hoisted_7 = { class: "coupon-condition" }
const _hoisted_8 = { class: "limit" }
const _hoisted_9 = { class: "express-tag" }
const _hoisted_10 = { class: "date" }
const _hoisted_11 = { class: "coupon-icon" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "g-button g-button-danger" }, "立即使用", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "coupon-desc" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc-label" }, "使用详情", -1))
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 1,
  class: "is-expired"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://res-cn.public.gblinker.com/gblinker/wechat_mini/images/2bb45916794124676275e35d17838ae3.png",
  mode: "widthFix"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.coupon.coupon_name), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.coupon.transaction_minimum > 0
                      ? '满' + _ctx.coupon.transaction_minimum + '元可用'
                      : '无门槛'), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.coupon.all_express_available ? '全线可用' : '部分线路可用'), 1)
              ]),
              _createElementVNode("div", _hoisted_10, " 使用时间 " + _toDisplayString(_ctx.coupon.effective_time) + "-" + _toDisplayString(_ctx.coupon.expiration_time), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: _ctx.coupon.icon_url,
                mode: "widthFix"
              }, null, 8, _hoisted_12)
            ])
          ]),
          (!_ctx.coupon.is_expiration)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "ctrl",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoOrdering && _ctx.gotoOrdering(...args)))
              }, _hoisted_14))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", {
              class: "article",
              innerHTML: _ctx.coupon.coupon_description
            }, null, 8, _hoisted_17)
          ]),
          (_ctx.coupon.is_expiration)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}